import {RListsHttp } from '@rhybus/api'

import { apiPath, fetchProvider } from './api'

export const anewRListsHttp = () => {
  try {
    return new RListsHttp(fetchProvider, apiPath)
  } catch (error) {
    console.error(`
    Error while fetching the API using endpoint RListsHttp. \n
    fetchProvider:${fetchProvider} \n
    apiPath:${apiPath} \n
    Error:${error}`)    
    throw error
  }
}
